export default "__VITE_ASSET__CbBpfXbz__"